import { render } from "./horizontalScroll.vue?vue&type=template&id=395736d8&scoped=true"
import script from "./horizontalScroll.vue?vue&type=script&lang=js"
export * from "./horizontalScroll.vue?vue&type=script&lang=js"

import "./horizontalScroll.vue?vue&type=style&index=0&id=395736d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395736d8"]])

export default __exports__